import * as React from "react";
import type { SVGProps } from "react";
const SvgFolderDown01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m14.4 13.8-2.454 2.443m0 0L9.6 13.91m2.346 2.333v-6M2.4 17.54V5.258a1.2 1.2 0 0 1 1.2-1.2h5.718l2.765 2.954H20.4a1.2 1.2 0 0 1 1.2 1.2v9.33a2.4 2.4 0 0 1-2.4 2.4L4.8 19.94a2.4 2.4 0 0 1-2.4-2.4"
    />
  </svg>
);
export default SvgFolderDown01;
